import React, {useContext} from "react";
import {AuthContext} from "../../providers/AuthProvider";
import {BYStatusButton} from "../inputs/BYStatusButtonGroup";
import {Statut} from "../types/Types";


interface BYChangeStatusButtonsProps {
    onChange: (newValue?: Statut) => void;
    disabled?: boolean;
}

const BYChangeStatusButtons = ({onChange, disabled}: BYChangeStatusButtonsProps) => {
    const {status} = useContext(AuthContext);

    return <div className="btn-group btn-group-sm" role="group" aria-label="Button group with nested dropdown">
        {status.map(s => {
            return <BYStatusButton key={s.refStatut}
                                   disabled={disabled}
                                   status={s}
                                   onClick={() => {
                                       onChange(s);
                                   }}
            />;
        })}
    </div>
};

export default BYChangeStatusButtons;